export default {"src":"/_next/static/media/research-mod.286ce029.svg","height":18,"width":16,"blurWidth":0,"blurHeight":0};